import {
  Banner,
  Button,
  ButtonGroup,
  Card,
  Frame,
  Layout,
  List,
  Page,
  Stack,
  Toast,
} from "@shopify/polaris";
import { EmailMajor, PhoneMajor } from "@shopify/polaris-icons";
import { useEffect, useState } from "react";
import "./index.scss";
import logo from "../../assets/images/superlemon-logo_2x.png";
import {
  COD_CANCELLED,
  COD_CONFIRMED,
  COD_LANGUAGES,
  COD_NO_RESPONSE,
  COD_PENDING,
  TEMPLATE_LANGUAGE_ARAB,
  TEMPLATE_LANGUAGE_ENG,
  TEMPLATE_LANGUAGE_HEBR,
  TEMPLATE_LANGUAGE_ITAL,
  TEMPLATE_LANGUAGE_SPAN,
  TEMPLATE_LANGUAGE_PORT,
  TEMPLATE_LANGUAGE_FREN,
  TEMPLATE_LANGUAGE_INDO,
  TEMPLATE_LANGUAGE_GERM,
  TEMPLATE_LANGUAGE_RUSSIAN,
  TEMPLATE_LANGUAGE_DUTCH,
  TEMPLATE_LANGUAGE_TURK,
} from "../../constants/constants";
import { useLocation } from "react-router-dom";
import {
  fetchCODOrder,
  fetchCODOrderEmail,
  updateCODOrderStatus,
} from "../../redux/actions/codSettings";

declare global {
  interface Window {
    opera: boolean;
  }
}

const CODPage = (props: any) => {
  const [token] = useState<string>(
    new URLSearchParams(useLocation().search).get("id") || ""
  );
  const [type] = useState<string>(
    new URLSearchParams(useLocation().search).get("type") || ""
  );
  const [shop, setShop] = useState({
    name: "",
    url: "",
  });
  const [translations, setTranslations] = useState<any>(
    COD_LANGUAGES["LANGUAGE_ENG"]
  );
  const [toast, setToast] = useState({ show: false, message: "" });
  const [errorToast, setErrorToast] = useState({ show: false, message: "" });
  const [orderDetails, setOrderDetails] = useState({
    address: "",
    amount: 0,
    currency: "",
    details: "",
    id: "",
    name: "",
    token: "",
    status: "",
    customerName: "",
    phone: "",
    createdOn: "",
  });
  const [settings, setSettings] = useState({
    call: "",
    email: "",
    lang: "ENGLISH",
    whatsapp: "",
  });

  // p: product, c: quantity, a: price
  const [lineItems, setLineItems] = useState<
    { p: string; c: number; a: number }[]
  >([]);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [orderStatus, setOrderStatus] = useState(COD_PENDING);
  const [cancelLoader, setCancelLoader] = useState(false);
  const [confirmLoader, setConfirmLoader] = useState(false);

  useEffect(() => {
    if (token) {
      props.hideFrame(false);
      if (type === "EMAIL") {
        loadDetailsEmail();
      } else {
        loadDetails();
      }
    }
  }, []);

  const showToast = (message: string) => {
    setToast({ show: true, message: message });
  };

  const showErrorToast = (message: string) => {
    setErrorToast({ show: true, message: message });
  };

  const loadDetails = () => {
    fetchCODOrder(token).then(
      (response: any) => {
        if (response.status === "success") {
          setOrderStatus(response.cod.message.action);
          setShop(response.cod.shop);
          setOrderDetails(response.cod.order);
          setSettings(response.cod.setting);
          setLineItems(response.cod.order.details);
          fetchTranslations(response.cod.setting.lang);
        } else {
          showErrorToast(response);
        }
      },
      (err) => {
        showErrorToast("Unable to fetch details");
      }
    );
  };
  const loadDetailsEmail = () => {
    fetchCODOrderEmail(token).then(
      (response: any) => {
        if (response.status === "success") {
          setOrderStatus(response.cod.message.action);
          setShop(response.cod.shop);
          setOrderDetails(response.cod.order);
          setSettings(response.cod.mailSetting);
          setLineItems(response.cod.order.details);
          fetchTranslations(response.cod.mailSetting.lang);
        } else {
          showErrorToast(response);
        }
      },
      (err) => {
        showErrorToast("Unable to fetch details");
      }
    );
  };

  const fetchTranslations = (language: string) => {
    switch (language) {
      case TEMPLATE_LANGUAGE_ENG:
        setTranslations(COD_LANGUAGES["LANGUAGE_ENG"]);
        break;
      case TEMPLATE_LANGUAGE_PORT:
        setTranslations(COD_LANGUAGES["LANGUAGE_PORT"]);
        break;
      case TEMPLATE_LANGUAGE_FREN:
        setTranslations(COD_LANGUAGES["LANGUAGE_FREN"]);
        break;
      case TEMPLATE_LANGUAGE_INDO:
        setTranslations(COD_LANGUAGES["LANGUAGE_INDO"]);
        break;
      case TEMPLATE_LANGUAGE_GERM:
        setTranslations(COD_LANGUAGES["LANGUAGE_GERM"]);
        break;
      case TEMPLATE_LANGUAGE_RUSSIAN:
        setTranslations(COD_LANGUAGES["LANGUAGE_RUSSIAN"]);
        break;
      case TEMPLATE_LANGUAGE_DUTCH:
        setTranslations(COD_LANGUAGES["LANGUAGE_DUTCH"]);
        break;
      case TEMPLATE_LANGUAGE_TURK:
        setTranslations(COD_LANGUAGES["LANGUAGE_TURK"]);
        break;
      case TEMPLATE_LANGUAGE_SPAN:
        setTranslations(COD_LANGUAGES["LANGUAGE_SPAN"]);
        break;
      case TEMPLATE_LANGUAGE_ITAL:
        setTranslations(COD_LANGUAGES["LANGUAGE_ITAL"]);
        break;
      case TEMPLATE_LANGUAGE_ARAB:
        setTranslations(COD_LANGUAGES["LANGUAGE_ARAB"]);
        break;
      case TEMPLATE_LANGUAGE_HEBR:
        setTranslations(COD_LANGUAGES["LANGUAGE_HEBR"]);
        break;
      default:
        setTranslations(COD_LANGUAGES["LANGUAGE_ENG"]);
        break;
    }
  };

  const formatDate = (date: any) => {
    var dateStr = new Date(date).toDateString().slice(4).split(" ");
    return `${dateStr[0]} ${dateStr[1]}, ${dateStr[2]}`;
  };

  const confirmOrder = () => {
    actOnOrder(2);
  };

  const cancelOrder = () => {
    actOnOrder(3);
  };

  const actOnOrder = (status: number) => {
    // status - 2 for confirm, 3 for cancel

    let params = new URLSearchParams();
    params.append("confirmation", status === 2 ? "true" : "false");

    showToast(
      "This process could take 5-7 seconds. Please do not refresh or close the page"
    );
    status === 2 ? setConfirmLoader(true) : setCancelLoader(true);
    updateCODOrderStatus(token, params).then(
      (response: any) => {
        if (response === 202) {
          showToast(
            `Order ${status === 2 ? "confirmed" : "cancelled"} successfully`
          );
          setTimeout(() => {
            if (type === "EMAIL") {
              loadDetailsEmail();
            } else {
              loadDetails();
            }
            setConfirmLoader(false);
            setCancelLoader(false);
          }, 6000);
        } else {
          showErrorToast(response);
        }
      },
      (err) => {
        showErrorToast("Unable to update order status");
      }
    );

    setBtnDisabled(true);
  };

  const mobilecheck = () => {
    var check = false;
    //eslint-disable-next-line
    (function (a: any) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  };

  const getWhatsappLink = () => {
    if (mobilecheck()) {
      return "api";
    }
    return "web";
  };

  const whatsappIcon = () => {
    return (
      <svg viewBox="0 0 48 46" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M34.6475 33.5968C32.1094 36.1348 25.6589 33.7974 20.2417 28.3802C14.8245 22.963 12.4871 16.5125 15.0251 13.9744L17.6535 11.3461C18.1149 10.8846 18.8573 10.8846 19.3188 11.3461L22.0073 14.0346C22.4688 14.4961 22.4688 15.2385 22.0073 15.6999L20.2417 18C18.8272 19.4145 21 22 24 25.5C27.2684 29.3132 29.6917 29.8649 31.1062 28.4504L32.922 26.6246C33.3834 26.1632 34.1258 26.1632 34.5873 26.6246L37.2758 29.3132C37.7373 29.7746 37.7373 30.517 37.2758 30.9785L34.6475 33.5968Z"
          fill="#5EC127"
        />
        <path
          d="M9.49974 39.6401C13.2617 43.1011 18.0168 45.2278 23.113 45.6993C27.5069 46.1106 31.9912 45.1676 35.8735 43.1011C43.4375 39.0883 48.2227 30.8822 47.992 22.3251C47.7813 13.8381 42.6952 5.8728 34.9907 2.24127C31.1084 0.405438 26.7345 -0.367016 22.4609 0.164673C18.1171 0.696362 14.0943 2.39175 10.6835 5.13045C3.57091 10.8185 0.571385 20.6196 3.13954 29.3373C3.52075 30.6314 4.03238 31.8955 4.62426 33.1093C4.62426 32.6077 4.62426 32.0961 4.62426 31.5945C3.33015 34.0824 2.03604 36.5603 0.741927 39.0482C0.551321 39.4093 0.370748 39.7604 0.180142 40.1216C-0.42177 41.2853 0.571385 42.6597 1.87553 42.3286C4.52394 41.6565 7.18238 40.9843 9.8308 40.3122C10.202 40.2219 10.5832 40.1216 10.9544 40.0313C11.7469 39.8307 12.2184 38.9479 12.0077 38.1754C11.787 37.3729 10.9443 36.9214 10.1518 37.1221C7.5034 37.7942 4.84496 38.4663 2.19655 39.1385C1.82537 39.2288 1.44416 39.3291 1.07298 39.4194C1.63476 40.1517 2.20658 40.894 2.76836 41.6264C3.94209 39.4194 5.09576 37.2023 6.24942 34.9752C6.51025 34.4837 6.76104 33.9921 7.02187 33.5006C7.08207 33.3902 7.14226 33.2698 7.20245 33.1595C7.24258 33.0792 7.26264 33.0391 7.30277 32.9388C7.57363 32.2666 7.2827 31.735 7.00181 31.133C5.83811 28.6351 5.22617 25.7158 5.22617 22.8969C5.22617 22.315 5.24623 21.7232 5.29639 21.1413C5.31646 20.8604 5.34655 20.5896 5.37665 20.3087C5.38668 20.2384 5.39671 20.1682 5.40674 20.098C5.40674 20.1181 5.37665 20.3388 5.39671 20.1582C5.41678 19.9977 5.44687 19.8372 5.46693 19.6867C5.65754 18.5531 5.94846 17.4295 6.31964 16.336C6.40993 16.0852 6.50022 15.8344 6.5905 15.5836C6.64066 15.4633 6.69082 15.3329 6.74098 15.2125C6.80117 15.052 6.73095 15.2426 6.72092 15.2626C6.75101 15.1824 6.79114 15.1021 6.83127 15.0219C7.05197 14.5203 7.30277 14.0187 7.56359 13.5271C8.08525 12.554 8.68716 11.6311 9.34927 10.7583C9.44958 10.6179 9.3292 10.7784 9.31917 10.7984C9.3593 10.7483 9.39943 10.6981 9.43955 10.648C9.51981 10.5477 9.60006 10.4473 9.69035 10.337C9.87092 10.1163 10.0615 9.90561 10.2521 9.68491C10.6133 9.27361 10.9945 8.88236 11.3958 8.50115C11.8071 8.10991 12.2384 7.7287 12.6798 7.36755C12.7802 7.2873 12.8805 7.20704 12.9908 7.11676C13.1212 7.0064 12.9607 7.13682 12.9507 7.14685C13.0009 7.10672 13.051 7.0666 13.1112 7.02647C13.3419 6.85593 13.5727 6.68538 13.8034 6.52488C14.7163 5.9029 15.6693 5.35115 16.6625 4.86962C16.9033 4.75927 17.144 4.64892 17.3848 4.53857C17.6456 4.41818 17.2443 4.58873 17.5152 4.48841C17.6557 4.42822 17.8061 4.37806 17.9466 4.31786C18.4682 4.11723 18.9999 3.93665 19.5416 3.78618C20.0834 3.62567 20.6351 3.49525 21.1869 3.37487C21.4778 3.31468 21.7687 3.26452 22.0596 3.21436C22.2001 3.1943 22.3305 3.17423 22.4709 3.15417C22.1901 3.1943 22.5913 3.14414 22.6916 3.12407C23.8553 2.99366 25.0291 2.95353 26.1928 3.01372C26.7746 3.04382 27.3464 3.09398 27.9283 3.1642C27.6675 3.13411 27.9784 3.17423 28.0687 3.18426C28.2092 3.20433 28.3396 3.22439 28.47 3.25449C28.7609 3.30465 29.0519 3.36484 29.3428 3.42503C30.4362 3.66579 31.5197 3.99685 32.563 4.40815C32.6232 4.42822 32.9442 4.55863 32.8138 4.50847C32.6834 4.45831 33.0044 4.58873 33.0646 4.61882C33.3455 4.74924 33.6264 4.87965 33.9073 5.0201C34.3988 5.27089 34.8804 5.53172 35.3619 5.81261C35.8334 6.09351 36.2949 6.39446 36.7463 6.71548C36.8566 6.79574 36.957 6.86596 37.0673 6.94621C37.1175 6.98634 37.3883 7.18698 37.278 7.10672C37.1676 7.02647 37.4385 7.23714 37.4886 7.27726C37.609 7.37758 37.7294 7.46787 37.8398 7.56819C38.6724 8.27042 39.4649 9.04287 40.1772 9.86549C40.3477 10.0661 40.5183 10.2668 40.6888 10.4674C40.7691 10.5677 40.8493 10.668 40.9396 10.7784C40.7691 10.5677 41.0098 10.8787 41.06 10.9489C41.391 11.3903 41.692 11.8418 41.9829 12.3133C42.2839 12.7948 42.5748 13.2964 42.8356 13.808C42.956 14.0488 43.0764 14.2795 43.1867 14.5203C43.2469 14.6407 43.2971 14.761 43.3573 14.8814C43.3874 14.9416 43.4075 15.0018 43.4375 15.062C43.4476 15.0921 43.5579 15.3429 43.4877 15.1924C43.4375 15.062 43.568 15.393 43.588 15.4432C43.6382 15.5636 43.6883 15.694 43.7285 15.8144C43.8288 16.0852 43.9291 16.3661 44.0194 16.637C44.1899 17.1687 44.3504 17.7104 44.4809 18.2622C44.6113 18.8139 44.7216 19.3757 44.8119 19.9375C44.8219 20.0278 44.8721 20.3488 44.832 20.0779C44.852 20.2184 44.8621 20.3488 44.8821 20.4892C44.9122 20.7902 44.9423 21.0911 44.9624 21.3921C45.0426 22.5859 45.0226 23.7797 44.9122 24.9735C44.9022 25.1139 44.8821 25.2443 44.8721 25.3848C44.8621 25.4851 44.8119 25.7961 44.852 25.5353C44.8119 25.8262 44.7617 26.1271 44.7116 26.4181C44.6113 26.9798 44.4809 27.5316 44.3304 28.0733C44.1799 28.615 44.0194 29.1467 43.8288 29.6784C43.7385 29.9292 43.6382 30.18 43.5479 30.4308C43.5278 30.491 43.4977 30.5512 43.4676 30.6214C43.4777 30.6013 43.5579 30.4107 43.4877 30.5713C43.4275 30.7117 43.3673 30.8521 43.2971 30.9926C42.8356 31.9958 42.3039 32.9689 41.692 33.8818C41.5516 34.1025 41.4011 34.3232 41.2406 34.5338C41.1603 34.6442 41.0901 34.7445 41.0098 34.8549C40.9697 34.905 40.9296 34.9552 40.8895 35.0154C40.749 35.1959 41.0299 34.8448 40.8794 35.0254C40.5283 35.4768 40.1571 35.9082 39.7659 36.3295C39.0235 37.1321 38.221 37.8745 37.3582 38.5667C37.3081 38.6068 37.2579 38.6469 37.2078 38.687C37.2278 38.677 37.3883 38.5466 37.2479 38.6569C37.1375 38.7372 37.0372 38.8174 36.9269 38.8877C36.6961 39.0582 36.4654 39.2187 36.2246 39.3792C35.7632 39.6902 35.3017 39.9711 34.8202 40.242C34.3386 40.5128 33.8471 40.7636 33.3455 40.9944C33.2251 41.0546 33.1047 41.1047 32.9843 41.1549C32.9041 41.195 32.6132 41.3054 32.8539 41.2151C32.5831 41.3254 32.3122 41.4257 32.0413 41.5261C30.9579 41.9173 29.8444 42.2283 28.7208 42.439C28.4499 42.4891 28.1791 42.5292 27.9082 42.5794C27.6173 42.6296 28.0587 42.5694 27.7577 42.5995C27.5972 42.6195 27.4367 42.6396 27.2762 42.6496C26.6944 42.7098 26.1125 42.7399 25.5307 42.7499C24.8585 42.76 24.1864 42.7499 23.5243 42.6998C23.1932 42.6797 22.8622 42.6396 22.5412 42.6095C22.3606 42.5894 22.501 42.6095 22.5311 42.6095C22.4509 42.5995 22.3706 42.5894 22.2904 42.5694C22.0998 42.5393 21.9192 42.5092 21.7286 42.4791C19.01 41.9975 16.7829 41.1348 14.4856 39.6902C13.9539 39.3592 13.4423 38.998 12.9407 38.6168C12.8002 38.5165 12.9106 38.5867 12.9407 38.6168C12.8805 38.5667 12.8203 38.5165 12.7601 38.4663C12.6397 38.366 12.5193 38.2657 12.399 38.1654C12.1381 37.9447 11.8873 37.724 11.6365 37.4932C11.0346 36.9415 10.1017 36.9014 9.50978 37.4932C8.94799 38.0751 8.89783 39.0883 9.49974 39.6401Z"
          fill="#5EC127"
        />
      </svg>
    );
  };

  const toastMarkup = toast.show ? (
    <Toast
      content={toast.message}
      onDismiss={() => {
        setToast({ show: false, message: "" });
      }}
    />
  ) : null;

  const errorToastMarkup = errorToast.show ? (
    <Toast
      error
      content={errorToast.message}
      onDismiss={() => {
        setErrorToast({ show: false, message: "" });
      }}
    />
  ) : null;

  return (
    <Frame>
      <div className="cod">
        {toastMarkup}
        {errorToastMarkup}
        <Page narrowWidth title={shop.name}>
          <div
            className={
              translations["language_direction"] === "rtl" ? "rtl-language" : ""
            }
          >
            <Layout>
              <Layout.Section>
                <p className="text-center mb-3">
                  <a
                    className="text-primary"
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`https://${shop.url}`}
                  >
                    {shop.url}
                  </a>
                </p>
                <Card>
                  <Card.Section>
                    <span className="order-name text-primary">
                      {orderDetails.name}
                    </span>
                    <span className="order-date">
                      {formatDate(orderDetails.createdOn)}
                    </span>
                  </Card.Section>
                  <Card.Section title={translations["order_details"]}>
                    <List type="bullet">
                      {lineItems.map((l, i) => {
                        return (
                          <List.Item key={i}>
                            <div className="Polaris-Stack Polaris-Stack--distributionEqualSpacing">
                              <div className="Polaris-Stack__Item item-description product-details">
                                <p>{`${l.p} (${l.c} x ${orderDetails.currency} ${l.a})`}</p>
                              </div>
                              <div className="Polaris-Stack__Item product-amount">
                                <p>{`${orderDetails.currency} ${(
                                  l.a * l.c
                                ).toFixed(2)}`}</p>
                              </div>
                            </div>
                          </List.Item>
                        );
                      })}
                    </List>
                    <br />

                    <div className="customStack">
                      <Stack distribution="equalSpacing">
                        <p>{`${translations["payable_amount"]}`}</p>
                        <p>
                          <b>{`${orderDetails.currency} ${orderDetails.amount}`}</b>
                        </p>
                      </Stack>
                    </div>
                  </Card.Section>

                  <Card.Section title={translations["shipping_details"]}>
                    <p className="mt-1">
                      <span className="text-uppercase">
                        {orderDetails.customerName}
                      </span>
                      <br />
                      <span className="pre-line">{orderDetails.address}</span>
                      <br />
                      {orderDetails.phone}
                    </p>
                  </Card.Section>

                  <Card.Section>
                    <Stack distribution="center">
                      <ButtonGroup>
                        <Button
                          onClick={() => cancelOrder()}
                          disabled={
                            btnDisabled || orderStatus === "COD_CONFIRMED" || orderStatus === "COD_CANCELLED"
                          }
                          loading={cancelLoader}
                        >
                          {translations["cancel_order"]}
                        </Button>

                        <Button
                          primary
                          onClick={() => confirmOrder()}
                          disabled={
                            btnDisabled || orderStatus === "COD_CONFIRMED" || orderStatus === "COD_CANCELLED"
                          }
                          loading={confirmLoader}
                        >
                          {translations["confirm_order"]}
                        </Button>
                      </ButtonGroup>
                    </Stack>

                    <div className="mt-3">
                      {orderStatus === COD_CONFIRMED ? (
                        <div>
                          <br />
                          <Banner
                            title={translations["confirmed_message"]}
                            status="success"
                          ></Banner>
                          <br />
                        </div>
                      ) : null}

                      {orderStatus === COD_CANCELLED ? (
                        <div>
                          <br />
                          <Banner
                            title={translations["cancelled_header"]}
                            status="success"
                          >
                            <p>{translations["cancelled_message"]}</p>
                          </Banner>
                          <br />
                        </div>
                      ) : null}

                      {orderStatus === COD_NO_RESPONSE ? (
                        <div>
                          <br />
                          <Banner
                            title={translations["no_response_header"]}
                            status="warning"
                          >
                            <p>{translations["no_response_message"]}</p>
                          </Banner>
                          <br />
                        </div>
                      ) : null}

                      {orderStatus === COD_PENDING ? (
                        <div>
                          <br />
                          <Banner title={translations["pending_order_header"]}>
                            <p>{translations["pending_order_message"]}</p>
                          </Banner>
                          <br />
                        </div>
                      ) : null}
                    </div>

                    <div className="mt-3 need-help">
                      <span className="need-help-info">
                        {translations["need_help"].replace(
                          "{{shop_name}}",
                          shop.name
                        )}
                      </span>
                      <ButtonGroup>
                        {settings.whatsapp ? (
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={`https://${getWhatsappLink()}.whatsapp.com/send?phone=${
                              settings.whatsapp
                            }&text=${
                              translations["whatsapp_help_message"]
                            } ${encodeURIComponent(orderDetails.name)}`}
                          >
                            <div className="ltr-language">
                              <Button
                                icon={whatsappIcon}
                                primary
                                outline
                              >{` WhatsApp`}</Button>
                            </div>
                          </a>
                        ) : null}
                        {settings.email ? (
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={`mailto:${settings.email}?subject=${translations["whatsapp_help_message"]} ${orderDetails.name}`}
                          >
                            <div className="ltr-language">
                              <Button
                                icon={EmailMajor}
                                primary
                                outline
                              >{` Email`}</Button>
                            </div>
                          </a>
                        ) : null}
                        {settings.call ? (
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={`tel:${settings.call}`}
                          >
                            <div className="ltr-language">
                              <Button
                                icon={PhoneMajor}
                                primary
                                outline
                              >{` Call`}</Button>
                            </div>
                          </a>
                        ) : null}
                      </ButtonGroup>
                    </div>
                  </Card.Section>
                </Card>
                <p className="powered-by">
                  <span className="strong">Powered by </span>
                  <br></br>
                  <a
                    href="https://apps.shopify.com/whatsapp-chat-button?utm_source=cod"
                    rel="noopener noreferrer"
                    target="_blank"
                    className="superlemon"
                  >
                    <img
                      src={logo}
                      alt="Powered By Superlemon"
                      className="logo"
                    />
                  </a>
                </p>
              </Layout.Section>
            </Layout>
          </div>
        </Page>
      </div>
    </Frame>
  );
};

export default CODPage;
